import * as React from 'react';

const NotFound = () => (
  <div>
    <h1>Page Not Found</h1>
    <p>The page you are looking for does not exist or you do not have permission to view it.</p>
  </div>
)
export default NotFound;


// WEBPACK FOOTER //
// ./src/common/routes/not-found.tsx